let currentTheme = "light";
let currentLanguage = "en";

export const postUISettingsToIframe = ({ theme, language }) => {
  if (theme !== undefined) {
    currentTheme = theme;
  }

  if (language !== undefined) {
    currentLanguage = language;
  }

  const iframe = document.getElementById("bot");
  if (!iframe?.contentWindow) return;

  const payload = {
    type: "hostUiSettings",
    theme: currentTheme,
    language: currentLanguage,
  };

  iframe.contentWindow.postMessage(payload, "*");
  console.log("Posted UI settings to iframe:", payload);
};

export function normalizeChatbotLanguage(i18nLanguage) {
  if (!i18nLanguage) return "en";

  const normalized = i18nLanguage.toLowerCase().replaceAll("-", "");
  const englishKeys = ["e", "en", "enca"];
  const frenchKeys = ["f", "fr", "frca"];

  if (frenchKeys.includes(normalized)) return "fr";
  if (englishKeys.includes(normalized)) return "en";
  return "en";
}

export function getHostThemeForChatbot() {
  const attr = document.documentElement.getAttribute("data-bs-theme");
  return attr === "dark" ? "dark" : "light";
}
